import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { LogService } from '../../../services/log.service';
import { TranslationService } from '../../../services/translation.service';
import { ConfigService } from '../../../services/config.service';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { DataIoService } from '../../../services/data-io.service';
import { ValueChangedConfirmation } from '../../../classes/ValueChangedConfirmation';
import { Helper, MenuNode, BaseSensor, ISensorInterface } from '../../../classes';

@Component({
  selector: 'app-eco',
  templateUrl: './eco.component.html',
  styleUrls: ['./eco.component.scss']
})
export class EcoComponent implements OnInit {
	chars = ['AICI_ON_NORMAL','AICI_OFF_NORMAL'];
	currentChar:string='';
	interval:any;
	_cursor = true;
	b():string{
		return this.translator.tr(this.currentChar,'en');
	}
	sub:any;
	constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private logger: LogService, 
        private config: ConfigService, 
        private translator:TranslationService,
        private navBar: NavBarService,
        private iconBar: IconBarService
        ){

	}
	blinkButton(){
	        this.menuService.blinkButton('confirm');
    }

	backClicked(){
		this.menuService.goto('dashboard');
	}
	upClicked(){
		
		this.blinkButton();
		let idx = this.chars.indexOf(this.currentChar);
		idx++;
		this.currentChar = this.chars[idx%this.chars.length];
		this.currentChar = this.currentChar.toUpperCase();
	}
	
	downClicked(){

		this.blinkButton();
		let idx = this.chars.indexOf(this.currentChar);
		idx--;
		if(idx == -1){
			idx = this.chars.length-1;
		}
		this.currentChar = this.chars[idx%this.chars.length];
	}
	
	confirmClicked(){
		this.menuService.buttonEnabled('up');
		this.menuService.buttonEnabled('down');
		this.ioService.deviceInfo().setValue('smarteco_mode',this.currentChar);
		if(this.currentChar == 'AICI_ON_NORMAL'){
			this.iconBar.enableIcon('ecomode');
		}else{
			this.iconBar.disableIcon('ecomode');
		}
		this.menuService.unblinkButton('confirm');
	}
	touched(){
		this.menuService.undisableButton('confirm');
	}
	eventHandler(e:string){
		switch(e){
			case 'up':{
				this.touched();
				this.upClicked();
				return;
			}
			case 'down':{
				this.touched();
				this.downClicked();
				return;
			}
			case 'confirm':{
				this.confirmClicked();

				return;
			}
			case 'menu':{
				this.menuService.goto('basic.timeset');
				return;
			}
			case 'back':{
				this.backClicked();
				return;
			}
			default:{

			}

		}
	}
	ngOnInit(){
		this.currentChar = this.ioService.deviceInfo().getRawValue('smarteco_mode');		
		this.sub = this.ioService.inputs.events$.subscribe( (e) => { this.eventHandler(e); } ) ;
		this.menuService.disableButton('confirm');
		this.interval = setInterval( ()=>{
			this._cursor = !this._cursor;
		},600);
		this.navBar.enableAll();
		this.navBar.blink('ecomode');

	}
	ngOnDestroy(){
		if(this.interval){
			clearInterval(this.interval);
		}
		if(this.sub){
			this.sub.unsubscribe();
		}
	}
}
